const statusB2BRequestCards = [ 
                      {'name':'Заявка в процессе заполнения','status':1, 'hidden':false , 'color':'90C6F3'}, 
                      {'name':'Заявка отправлена на проверку','status':2, 'hidden':false, 'color':'F7CE46'},
                      {'name':'Нужны правки ','status':0, 'hidden':false, 'color':'F8D6E0'},
                      {'name':'Заявитель сделал запрос на изменения данных! ','status':90, 'hidden':false, 'color':'F8D6E0'}, 
                      {'name':'Заявитель получил одобрение по договору,<br>ожидается скан с подписью','status':3, 'hidden':false, 'color':'FFFFFF'},
                      {'name':'Заявитель загрузил скан, ожидается проверка организатором','status':4, 'hidden':false, 'color':'A5E8E3'},
                      {'name':'Заявитель указал неверный скан<br>!СТОП!','status':5, 'hidden':false, 'color':'F8D6E0'},
                      {'name':'Скан договора одобрен,<br>открыт доступ к ссылкам','status':6, 'hidden':false, 'color':'65A968'},
                      {'name':'Заявитель заполнил <br> результаты голосования','status':7, 'hidden':false, 'color':'D5F4F2'},
                      {'name':'Заявитель заполнил форму отчета <br>и загрузил фото','status':8, 'hidden':false, 'color':'F7CE46'},
                      {'name':'Организатор не одобрил форму отчета или фото','status':9, 'hidden':false, 'color':'F8D6E0'},
                      {'name':'Отчетные данные проверены<br>ожидаем скан отчета','status':10, 'hidden':false, 'color':'90C6F3'},
                      {'name':'Заявитель загрузил скан формы отчета','status':11, 'hidden':false, 'color':'F7CE46'},
                      {'name':'Заявитель допустил ошибки<br> в скане с отчетом','status':12, 'hidden':false, 'color':'F8D6E0'},
                      {'name':'Заявитель все заполнил верно.<br> Отчет сдан.<br> Работа окончена','status':13, 'hidden':false, 'color':'65A968'},
                      {'name':'Отказ в заявке ','status':99, 'hidden':true, 'color':'F8D6E0'},
                      {'name':'Прошлогодняя заявка','status':91, 'hidden':false, 'color':'E0E3E6'} ];





export default {
	statusB2BRequestCards
};